import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { INoContent } from './types';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'react-feather';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    icon: {
        color: theme.palette.secondary.main,
        height: 24,
        width: 24,
    },
}));

export const NoContent = ({ type, ...props }: INoContent) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.root} {...props}>
            <AlertCircle className={classes.icon} />
            <Typography variant="body1" color="textSecondary">
                {t('Charts.ThereIsNoContent', {
                    type: t(`ModalFilters.${type}`),
                })}
            </Typography>
        </Box>
    );
};
